import { Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import OnlineMenuStartup from "../../page/startup/OnlineMenuStartup";
import OnlineMenuHome from "../../page/home/OnlineMenuHome";
import Cart from "../../page/cart/cart";
import VerifyPage from "../../page/verify_page/verify_page";
import React from "react";
import { ToastContainer } from "react-toastify";

export const router = () => {
  function navigationRoute() {
    return (
      <Routes>
        <Route path={routes.initial} element={<OnlineMenuStartup />}></Route>
        <Route path={routes.food}>
          <Route path={":id"} element={<OnlineMenuHome />}></Route>
        </Route>
        <Route path={routes.cart} element={<Cart />}></Route>
        <Route path={routes.verify} element={<VerifyPage />}></Route>
      </Routes>
    );
  }

  return navigationRoute();
};
